The criteria to filter events by.

These are `Event`-specific extensions on top of the standard pagination arguments `before`, `after`, `first` and `last`.
